import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import TagManager from 'react-gtm-module';
import { Collapse } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { FormCheckbox, FormNumber, FormSelect, PaymentMethod } from '.';
import focusInputOnError from '../helpers/focusInputOnError';
import validate from '../helpers/paymentFormValidate';
import {
  banks,
  billingDays,
  formatPrice,
  formatUfPrice,
  getYearsForCreditCard,
  months,
  planCharacteristics,
} from '../helpers/utils';
import { IPlan } from '../store/Quote';
import Loading from './Loading';
import { env } from '../env';

const years = getYearsForCreditCard();

interface IPaymentFormProps {
  changePaymentMethod: (method: string) => void;
  documentId: string;
  fullName: string;
  handleSubmit?: (payload: any) => void;
  onSubmit: any;
  plan: IPlan;
  previousPage: () => void;
  emitting: boolean;
}

export function PaymentForm(props: IPaymentFormProps) {
  const {
    changePaymentMethod,
    documentId,
    fullName,
    handleSubmit,
    plan,
    previousPage,
    emitting,
  } = props;
  const [collapseCMR, setCollapseCMR] = useState(false);
  const [collapseWebpay, setCollapseWebpay] = useState(true);
  const [collapseMandate, setCollapseMandate] = useState(false);
  const [webpayCard, setWebpayCard] = useState('');
  const [webpayCardExpireMonth, setWebpayCardExpireMonth] = useState('');
  const [webpayCardExpireYear, setWebpayCardExpireYear] = useState('');
  const toggleCollapse = (method: string) => {
    if (method === 'CMR') {
      setCollapseCMR(false);
      setCollapseWebpay(false);
      setCollapseMandate(false);
      changePaymentMethod(method);
    } else if (method === 'OTHERS') {
      setCollapseCMR(false);
      setCollapseWebpay(true);
      setCollapseMandate(false);
      changePaymentMethod(method);
    } else {
      setCollapseCMR(false);
      setCollapseWebpay(false);
      setCollapseMandate(true);
      changePaymentMethod(method);
    }
  };
  const handleWebpayCardChange = ({ target: { value } }: any) =>
    setWebpayCard(value);
  const handleWebpayCardExpireMonthChange = ({ target: { value } }: any) =>
    setWebpayCardExpireMonth(value);
  const handleWebpayCardExpireYearChange = ({ target: { value } }: any) =>
    setWebpayCardExpireYear(value);
  const webpayCardExpireDate = `${webpayCardExpireMonth}${webpayCardExpireYear}`;

  useEffect(() => {
    window.scrollTo(0, 0);

    if (env.REACT_APP_ENVIRONMENT === 'production' || env.REACT_APP_GTM_QA_ACTIVE === 'true') {
      const tagManagerArgs = {
        dataLayer: {
          event: 'vpvPayment',
        },
        dataLayerName: 'datalayer',
      };

      TagManager.dataLayer(tagManagerArgs);

      ReactGA.send({
        hitType: 'pageview',
        location: 'salud.segurosfalabella.com/salud/pago',
        title: 'Seguro Salud Complementario',
        user_id: sessionStorage.getItem('userId')
      });

      // Funnel step viewed
      ReactGA.event("funnel_step_viewed", {
        'funnel_name': 'contratacion-seguro',
        'product_name': 'web-salud-complementario',
        'funnel_step_name': 'paso-pago'
      });
    }
  }, []);

  const urlPdf = planCharacteristics[plan.plan_id].beneficsPdf;

  const textTerms = <div>
    <p className="px-14">
      Al Seleccionar esta casilla aceptas los&nbsp;
      <a
        href={urlPdf}
        target="_blank"
        rel="noreferrer noopener"
      >
        términos y condiciones&nbsp;
      </a>
      del seguro y declaras conocer&nbsp;
      <a
        href="https://sfestaticos.blob.core.windows.net/chile/pdf/politica-de-privacidad-protocolizada-seguros.pdf"
        target="_blank"
        rel="noreferrer noopener"
      >
        nuestra política de privacidad.&nbsp;
      </a>
      También declaras ser asegurado y pagador de este seguro.
    </p>
  </div>

  return (
    <div className="container">
      {!emitting && (
        <div className="row">
          <div className="col-12 mb50">
            <h1 className="text-center mt30">Medio de Pago</h1>
            <div className="row mt10 justify-content-center">
              {/* <PaymentMethod
                active={collapseCMR}
                imgUrl="//sfestaticos.blob.core.windows.net/guideline/payment-logos/CMR.svg"
                name="CMR"
                description="CMR / Visa CMR / Mastercard CMR"
                select={toggleCollapse}
              /> */}
              <PaymentMethod
                active={collapseWebpay}
                imgUrl="https://sfestaticos.blob.core.windows.net/pmc/vida/assets/payment-home.png"
                name="OTHERS"
                description="Paga con tarjetas de crédito"
                select={toggleCollapse}
              />
              {/* <PaymentMethod
                active={collapseMandate}
                imgUrl="//sfestaticos.blob.core.windows.net/guideline/payment-logos/PAC.svg"
                name="MANDATE"
                description="Pago Automático Cuenta Corriente"
                select={toggleCollapse}
              /> */}
              <div className="col-12 sf-alert sf-alert--warning"><p className='px-16 mb0 text-left'>Recuerda que solo podrás pagar este seguro con tarjeta de crédito.</p></div>
              <Collapse className="col-12 mt30" isOpen={collapseWebpay}>
                <form onSubmit={handleSubmit} noValidate={true}>
                  <Field name="paymentMethod" component="input" type="hidden" />
                  <div className="col-12 wizard-card">
                    <div className="row">
                      <div className="col-12 col-sm-6">
                        <div className="row mb-25">
                          <div className="col-12">
                            <Cards
                              number={webpayCard}
                              name={fullName}
                              expiry={webpayCardExpireDate}
                              cvc=""
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 form-group mb0">
                            <div>
                              <span className="text-bold">Rut</span>
                              <p>{documentId}</p>
                            </div>
                          </div>
                          <div className="w-100 d-none d-sm-block" />
                          <div className="col-12 col-md-10 col-lg-8 form-group mb20">
                            <label htmlFor="webpayCard">
                              Número de tarjeta de crédito
                            </label>
                            <Field
                              name="webpayCard"
                              placeholder="1234 5678 9012 3456"
                              inputFormat="#### #### #### ####"
                              component={FormNumber}
                              value={webpayCard}
                              onChange={handleWebpayCardChange}
                            />
                          </div>
                          <div className="col-12">
                            <div className="row">
                              <div className="col-12 col-sm-4 form-group">
                                <label htmlFor="webpayCardMonth">Mes</label>
                                <Field
                                  name="webpayCardMonth"
                                  placeholder="Selecciona..."
                                  options={months}
                                  component={FormSelect}
                                  value={webpayCardExpireMonth}
                                  onChange={handleWebpayCardExpireMonthChange}
                                />
                              </div>
                              <div className="col-12 col-sm-4 form-group">
                                <label htmlFor="webpayCardYear">Año</label>
                                <Field
                                  name="webpayCardYear"
                                  placeholder="Selecciona..."
                                  options={years}
                                  component={FormSelect}
                                  value={webpayCardExpireYear}
                                  onChange={handleWebpayCardExpireYearChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 border-left pt20 pb20 product-resume-payment">
                        <div className="row">
                          <article className="col-12 col-sm-8 mx-auto">
                            <div className="product-card no-shadow mb0">
                              <section className="recommended-section">
                                <h3>{plan.name}</h3>
                                <hr />
                              </section>
                              <section>
                                <figure>
                                  <img
                                    src="https://sfestaticos.blob.core.windows.net/guideline/companies/metlife.svg"
                                    alt="Metlife"
                                  />
                                </figure>
                                <hr />
                                <h3 className="product-card--price">
                                  <span>
                                    <img
                                      src="https://sfestaticos.blob.core.windows.net/pmc/vida/assets/svg/money.svg"
                                      alt="Simbolo Moneda"
                                      height="20px"
                                    />
                                  </span>
                                  {formatPrice(plan.premium_monthly_CLP)}
                                </h3>
                                <p className="mb0">
                                  UF {formatUfPrice(plan.premium_monthly)}{' '}
                                  mensuales
                                </p>
                              </section>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center buttons-container text-center">
                    <div className="row mt20">
                      <div className="col-12 col-sm-auto mx-auto mt10">
                        <p className="px-14">
                          Recuerda que tienes derecho a retracto en la compra de nuestro seguro.
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-auto mx-auto mt10">
                        <Field name="declarationCard" component={FormCheckbox} text={textTerms} value="declarationCard"/>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center mt50 buttons-container">
                    <div className="col-12 col-sm-5 col-md-4">
                      <button
                        className="btn white back-to-dps-from-payment"
                        type="button"
                        onClick={previousPage}
                      >
                        Volver
                      </button>
                    </div>
                    <div className="col-12 col-sm-5 col-md-4">
                      <button className="btn primary pay-button" type="submit">
                        Pagar
                      </button>
                    </div>
                  </div>
                </form>
              </Collapse>
              <Collapse className="col-12 mt30" isOpen={collapseCMR}>
                <form onSubmit={handleSubmit} noValidate={true}>
                  <Field name="paymentMethod" component="input" type="hidden" />
                  <div className="col-12 wizard-card">
                    <div className="row">
                      <div className="col-12 col-sm-6">
                        <div className="row">
                          <div className="col-12 col-sm-6 form-group">
                            <div>
                              <span className="text-bold">Rut</span>
                              <p>{documentId}</p>
                            </div>
                          </div>
                          <div className="w-100 d-none d-sm-block" />
                          <div className="col-12 col-sm-8 form-group mb0">
                            <label htmlFor="cmrCard">
                              Número de tarjeta CMR
                            </label>
                            <Field
                              name="cmrCard"
                              placeholder="1234 5678 9012 3456"
                              inputFormat="#### #### #### ####"
                              component={FormNumber}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 border-left pt20 pb20 product-resume-payment">
                        <div className="row">
                          <article className="col-12 col-sm-8 mx-auto">
                            <div className="product-card no-shadow mb0">
                              <section className="recommended-section">
                                <h3>{plan.name}</h3>
                                <hr />
                              </section>
                              <section>
                                <figure>
                                  <img
                                    src="https://sfestaticos.blob.core.windows.net/guideline/companies/metlife.svg"
                                    alt="Metlife"
                                  />
                                </figure>
                                <hr />
                                <h3 className="product-card--price">
                                  <span>
                                    <img
                                      src="https://sfestaticos.blob.core.windows.net/pmc/vida/assets/svg/money.svg"
                                      alt="Simbolo Moneda"
                                      height="20px"
                                    />
                                  </span>
                                  {formatPrice(plan.premium_monthly_CLP)}
                                </h3>
                                <p className="mb0">
                                  UF {formatUfPrice(plan.premium_monthly)}{' '}
                                  mensuales
                                </p>
                              </section>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center buttons-container text-center">
                    <div className="row mt20">
                      <div className="col-12 col-sm-auto mx-auto mt10">
                        <p className="px-14">
                          Recuerda que tienes derecho a retracto en la compra de nuestro seguro.
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-auto mx-auto mt10">
                        <Field name="declarationCard" component={FormCheckbox} text={textTerms} value="declarationCard" />
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center mt50 buttons-container">
                    <div className="col-12 col-sm-5 col-md-4">
                      <button
                        className="btn white back-to-dpsback-to-dps-from-payment-from-payment"
                        type="button"
                        onClick={previousPage}
                      >
                        Volver
                      </button>
                    </div>
                    <div className="col-12 col-sm-5 col-md-4">
                      <button className="btn primary pay-button" type="submit">
                        Pagar
                      </button>
                    </div>
                  </div>
                </form>
              </Collapse>
              <Collapse className="col-12 mt30" isOpen={collapseMandate}>
                <form onSubmit={handleSubmit} noValidate={true}>
                  <Field name="paymentMethod" component="input" type="hidden" />
                  <div className="col-12 wizard-card">
                    <div className="row">
                      <div className="col-12 order-2 order-sm-0 payment-pac">
                        <h2 className="px-28 d-none d-sm-block text-center mb10">
                          Pasos importantes para suscribir tu PAC
                        </h2>
                        <h2 className="px-20 d-block d-sm-none mt30">
                          Pasos importantes para
                          <br />
                          suscribir tu PAC
                        </h2>
                        <h3 className="px-28 d-none d-sm-block text-green text-center mb40">
                          Considera estos pasos y así obtendrás tu póliza ;)
                        </h3>
                        <h3 className="px-20 d-block d-sm-none text-green mb40">
                          Considera estos pasos y así obtendrás tu póliza ;)
                        </h3>
                      </div>
                      <div className="col-12 d-flex flex-wrap mb30 order-3 order-sm-1 payment-pac">
                        <div className="col-12 col-sm-3">
                          <figure className="payment-instructions">
                            <span className="step">1</span>
                            <div className="image-container d-none d-md-block">
                              <img
                                src="//sfestaticos.blob.core.windows.net/guideline/icons/banco.svg"
                                alt="Banco"
                              />
                            </div>
                            <figcaption>Suscribe el PAC a tu banco</figcaption>
                          </figure>
                        </div>
                        <div className="col-12 col-sm-3">
                          <figure className="payment-instructions">
                            <span className="step">2</span>
                            <div className="image-container d-none d-md-block">
                              <img
                                src="https://sfestaticos.blob.core.windows.net/guideline/icons/mail-payment.svg"
                                alt="Correo"
                              />
                            </div>
                            <figcaption>
                              Recibirás un correo con instrucciones
                            </figcaption>
                          </figure>
                        </div>
                        <div className="col-12 col-sm-3">
                          <figure className="payment-instructions">
                            <span className="step">3</span>
                            <div className="image-container d-none d-md-block">
                              <img
                                src="https://sfestaticos.blob.core.windows.net/guideline/icons/no-pago.svg"
                                alt="No pago"
                              />
                            </div>
                            <figcaption>
                              Para no tener problemas de pago comprueba tu
                              suscripción
                            </figcaption>
                          </figure>
                        </div>
                        <div className="col-12 col-sm-3">
                          <figure className="payment-instructions">
                            <span className="step">4</span>
                            <div className="image-container d-none d-md-block">
                              <img
                                src="https://sfestaticos.blob.core.windows.net/guideline/icons/tiempo.svg"
                                alt="Tiempo"
                              />
                            </div>
                            <figcaption>
                              Tienes hasta 5 días para suscribir tu PAC
                            </figcaption>
                          </figure>
                        </div>
                        <div className="w-100 d-block d-sm-none mb30" />
                      </div>
                      <div className="col-12 mb30 d-none d-sm-block order-4">
                        <h2 className="px-20">
                          La cuenta corriente que ingreses debe estar a
                          <span className="text-primary">
                            &nbsp;nombre del RUT asegurado.
                          </span>
                        </h2>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-6 order-1 order-sm-3">
                        <div className="row">
                          <div className="col-12 form-group">
                            <div>
                              <span className="text-bold">Rut</span>
                              <p>{documentId}</p>
                            </div>
                          </div>
                          <div className="w-100 d-none d-sm-block" />
                          <div className="col-12 col-sm-10 form-group mb20">
                            <label htmlFor="banco">Seleccionar Banco</label>
                            <Field
                              name="nameBank"
                              component={FormSelect}
                              options={banks}
                              placeholder="Selecciona..."
                            />
                          </div>
                          <div className="col-12 col-sm-10 form-group">
                            <label htmlFor="cuenta">
                              Nº de Cuenta Corriente
                            </label>
                            <Field
                              name="accountBank"
                              placeholder="24500033"
                              inputFormat="################"
                              component={FormNumber}
                            />
                          </div>
                          <div className="col-12 col-sm-10 form-group">
                            <label htmlFor="diacobro">Día de cobro</label>
                            <Field
                              name="billingDay"
                              component={FormSelect}
                              options={billingDays}
                              placeholder="Selecciona..."
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 border-left pt20 pb20 order-4 order-sm-4">
                        <div className="row">
                          <article className="col-12 col-lg-8 mx-auto">
                            <div className="product-card no-shadow mb0">
                              <section className="recommended-section">
                                <h3>{plan.name}</h3>
                                <hr />
                              </section>
                              <section>
                                <figure>
                                  <img
                                    src="https://sfestaticos.blob.core.windows.net/guideline/companies/metlife.svg"
                                    alt="Metlife"
                                  />
                                </figure>
                                <hr />
                                <h3 className="product-card--price">
                                  <span>
                                    <img
                                      src="https://sfestaticos.blob.core.windows.net/pmc/vida/assets/svg/money.svg"
                                      alt="Simbolo Moneda"
                                      height="20px"
                                    />
                                  </span>
                                  {formatPrice(plan.premium_monthly_CLP)}
                                </h3>
                                <p className="mb0">{`UF ${plan.premium_monthly} mensuales`}</p>
                              </section>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center buttons-container text-center">
                    <div className="row mt20">
                      <div className="col-12 col-sm-auto mx-auto mt10">
                        <p className="px-14">
                          Recuerda que tienes derecho a retracto en la compra de nuestro seguro.
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-auto mx-auto mt10">
                        <Field name="declarationCard" component={FormCheckbox} text={textTerms} value="declarationCard" />
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center mt50 buttons-container">
                    <div className="col-12 col-sm-5 col-md-4">
                      <button
                        className="btn white back-to-dpsback-to-dps-from-payment-from-payment"
                        type="button"
                        onClick={previousPage}
                      >
                        Volver
                      </button>
                    </div>
                    <div className="col-12 col-sm-5 col-md-4">
                      <button className="btn primary pay-button" type="submit">
                        Pagar
                      </button>
                    </div>
                  </div>
                </form>
              </Collapse>
            </div>
          </div>
        </div>
      )}
      {emitting && <Loading />}
    </div>
  );
}

export default reduxForm<any, IPaymentFormProps>({
  form: 'proposal',
  onSubmitFail: focusInputOnError,
  validate,
})(PaymentForm);
